export const TRAVEL_UPSELL_FIELDS = `
  id
  name
  product
  isActive
  priority
  placements
  conditionGroups {
    conditions {
      property
      operator
      values
    }
  }
  maxOffers
  contents {
    locale
    title
    subtitle
    ctaLabel
  }
  imageUrl
  updatedAt
`;

export const TRAVEL_BOOKING_UPSELL_FIELDS = `
  id
  upsellId
  product
  title
  subtitle
  ctaLabel
  imageUrl
  destinationName
  searchUrl
  hasLiveOffers
  offers {
    id
    name
    imageUrl
    price
    currency
    url
  }
`;

export const TRAVEL_UPSELL_DESTINATION_FIELDS = `
  id
  matchType
  matchValue
  countryCode
  tourDestinationId
  tourDestinationName
  hotelDestinationId
  hotelDestinationName
  updatedAt
`;
